import PropTypes from 'prop-types'

/**
 * @typedef {string[]} ControlFlags
 */
export const controlFlagsPropType = PropTypes.arrayOf(PropTypes.string)
